import React from "react";
import { useParams } from "react-router-dom";
import LayoutNoVideo from "../components/common/LayoutNoVideo.jsx";
import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { posts as staticPosts } from "../static/posts.js";

// Función para convertir título a un formato URL amigable (slug)
const slugify = (text) => {
    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')       // Reemplaza espacios con guiones
        .replace(/[^\w\-]+/g, '')   // Elimina caracteres no-alfanuméricos
        .replace(/\-\-+/g, '-');    // Reemplaza múltiples guiones con uno solo
};

const BackToHomeButton = () => (
    <Link
        to="/blog"
        className="fixed bottom-6 left-6 z-40 flex items-center gap-2 bg-white/80 dark:bg-[#1a3a3a] text-primary dark:text-lightGreen 
    hover:bg-secondary hover:text-white px-4 py-2 rounded-full shadow-lg transition-all duration-300"
    >
        <span className="text-lg">←</span>
        <span className="hidden sm:inline font-semibold">Back to Blog</span>
    </Link>
);

const Post = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);

    useEffect(() => {
        // Busca el post cuyo título slugificado coincida con el slug de la URL
        const foundPost = staticPosts.find(p => slugify(p.title) === slug);

        if (foundPost) {
            console.log("Post data:", foundPost);
            setPost(foundPost);
        } else {
            console.error("Error loading post: Post not found with slug", slug);
        }
    }, [slug]);

    if (!post) return <p className="text-center mt-10">Loading...</p>;

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        "headline": post.title,
        "description": post.excerpt || "Artículo en Slowork",
        "datePublished": new Date(post.date).toISOString(),
        "author": {
            "@type": "Person",
            "name": "Slowork"
        },
        ...(post.image && { "image": post.image })
    };

    return (
        <>
            <Helmet>
                <title>{post.title} - Slowork</title>
                <meta name="description" content={post.excerpt || "Artículo en Slowork"} />
                <meta property="og:title" content={post.title} />
                <meta property="og:description" content={post.excerpt || "Artículo en Slowork"} />
                <meta property="og:type" content="article" />
                <meta property="og:url" content={`https://slowork.app/blog/${slug}`} />
                {post.image && <meta property="og:image" content={post.image} />}
                <script type="application/ld+json">
                    {JSON.stringify(jsonLd)}
                </script>
            </Helmet>
            <LayoutNoVideo>
                <BackToHomeButton />

                <article className="bg-white/90 dark:bg-[#112626]/90 p-8 rounded-xl shadow-lg max-w-3xl w-full text-gray-900 dark:text-gray-100">
                    <h1 className="text-3xl font-bold text-center mb-4 text-secondary dark:text-lightGreen">
                        {post.title}
                    </h1>
                    <p className="text-sm text-center text-gray-500 dark:text-gray-400 mb-6">
                        Published on {new Date(post.date).toLocaleDateString()}
                    </p>

                    <div className="prose prose-lg dark:prose-invert max-w-none">
                        <ReactMarkdown
                            remarkPlugins={[remarkGfm]}
                            components={{
                                img: ({ node, ...props }) => (
                                    <img
                                        {...props}
                                        className="my-6 mx-auto rounded-lg shadow-md w-full max-w-[600px] max-h-[500px]"
                                        alt={props.alt || "Image"}
                                    />
                                ),
                                a: ({ node, ...props }) => (
                                    <a
                                        {...props}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-green-600 hover:text-green-500 underline"
                                    />
                                )
                            }}
                        >
                            {post.content}
                        </ReactMarkdown>

                    </div>
                </article>

            </LayoutNoVideo>
        </>
    );
};

export default Post;
